
import { Routes, Route } from 'react-router-dom'

import Driver from './driver'
import Contract from './contract'
import Vehicle from './vehicle'
import Variations from './variations'
import ServiceBookings from './service-bookings'
import FBT from './fbt'

import { constants } from '../../module'
import { constants as fromRequestVariationSummary } from 'features/request-contract-variations'

const DrillDownRoutes = () => {

  const isServiceTrackingPage = window.location.pathname.includes('/reports/vehicle-servicing')
  const isKMTrackingPage = window.location.pathname.includes('/reports/km-tracking')
  const isRequestVariationSummaryPage = window.location.pathname.includes('/contract-variations')
  const isTFSFleetPage = window.location.pathname.includes('/fleet')
  const isExceptionsPage = window.location.pathname.includes('/reports/fuel-exceptions')

  const fromKmTracking = {
    ROUTE_CONTACT: `/reports/km-tracking/:id/contract-details`,
    ROUTE_DRIVER: `/reports/km-tracking/:id/driver-details`,
    ROUTE_VEHICLE: `/reports/km-tracking/:id/service-history`,
    ROUTE_VARIATIONS: `/reports/km-tracking/:id/variations`,
    ROUTE_SERVICE_BOOKINGS: `/reports/km-tracking/:id/service-bookings`,
    ROUTE_FBT: `/reports/km-tracking/:id/fbt`,
  }

  const fromServiceTracking = {
    ROUTE_CONTACT: `/reports/vehicle-servicing/:id/contract-details`,
    ROUTE_DRIVER: `/reports/vehicle-servicing/:id/driver-details`,
    ROUTE_VEHICLE: `/reports/vehicle-servicing/:id/service-history`,
    ROUTE_VARIATIONS: `/reports/vehicle-servicing/:id/variations`,
    ROUTE_SERVICE_BOOKINGS: `/reports/vehicle-servicing/:id/service-bookings`,
    ROUTE_FBT: `/reports/vehicle-servicing/:id/fbt`,
  }

  const fromExceptionsTracking = {
    ROUTE_CONTACT: `/reports/fuel-exceptions/:id/contract-details`,
    ROUTE_DRIVER: `/reports/fuel-exceptions/:id/driver-details`,
    ROUTE_VEHICLE: `/reports/fuel-exceptions/:id/service-history`,
    ROUTE_VARIATIONS: `/reports/fuel-exceptions/:id/variations`,
    ROUTE_SERVICE_BOOKINGS: `/reports/fuel-exceptions/:id/service-bookings`,
    ROUTE_FBT: `/reports/fuel-exceptions/:id/fbt`,
  }

  return (
    <Routes>
      {isRequestVariationSummaryPage && <Route path={fromRequestVariationSummary.ROUTE_CONTACT} element={<Contract />} />}
      {isRequestVariationSummaryPage && <Route path={fromRequestVariationSummary.ROUTE_DRIVER} element={<Driver />} />}
      {isRequestVariationSummaryPage && <Route path={fromRequestVariationSummary.ROUTE_VEHICLE} element={<Vehicle />} />}
      {isRequestVariationSummaryPage && <Route path={fromRequestVariationSummary.ROUTE_VARIATIONS} element={<Variations />} />}
      {isRequestVariationSummaryPage && <Route path={fromRequestVariationSummary.ROUTE_SERVICE_BOOKINGS} element={<ServiceBookings />} />}
      {isRequestVariationSummaryPage && <Route path={fromRequestVariationSummary.ROUTE_FBT} element={<FBT />} />}

      {isServiceTrackingPage && <Route path={fromServiceTracking.ROUTE_CONTACT} element={<Contract />} />}
      {isServiceTrackingPage && <Route path={fromServiceTracking.ROUTE_DRIVER} element={<Driver />} />}
      {isServiceTrackingPage && <Route path={fromServiceTracking.ROUTE_VEHICLE} element={<Vehicle />} />}
      {isServiceTrackingPage && <Route path={fromServiceTracking.ROUTE_VARIATIONS} element={<Variations />} />}
      {isServiceTrackingPage && <Route path={fromServiceTracking.ROUTE_SERVICE_BOOKINGS} element={<ServiceBookings />} />}
      {isServiceTrackingPage && <Route path={fromServiceTracking.ROUTE_FBT} element={<FBT />} />}

      {isKMTrackingPage && <Route path={fromKmTracking.ROUTE_CONTACT} element={<Contract />} />}
      {isKMTrackingPage && <Route path={fromKmTracking.ROUTE_DRIVER} element={<Driver />} />}
      {isKMTrackingPage && <Route path={fromKmTracking.ROUTE_VEHICLE} element={<Vehicle />} />}
      {isKMTrackingPage && <Route path={fromKmTracking.ROUTE_VARIATIONS} element={<Variations />} />}
      {isKMTrackingPage && <Route path={fromKmTracking.ROUTE_SERVICE_BOOKINGS} element={<ServiceBookings />} />}
      {isKMTrackingPage && <Route path={fromKmTracking.ROUTE_FBT} element={<FBT />} />}

      {isTFSFleetPage && <Route path={constants.ROUTE_CONTACT} element={<Contract />} />}
      {isTFSFleetPage && <Route path={constants.ROUTE_DRIVER} element={<Driver />} />}
      {isTFSFleetPage && <Route path={constants.ROUTE_VEHICLE} element={<Vehicle />} />}
      {isTFSFleetPage && <Route path={constants.ROUTE_VARIATIONS} element={<Variations />} />}
      {isTFSFleetPage && <Route path={constants.ROUTE_SERVICE_BOOKINGS} element={<ServiceBookings />} />}
      {isTFSFleetPage && <Route path={constants.ROUTE_FBT} element={<FBT />} />}

      {isExceptionsPage && <Route path={fromExceptionsTracking.ROUTE_CONTACT} element={<Contract />} />}
      {isExceptionsPage && <Route path={fromExceptionsTracking.ROUTE_DRIVER} element={<Driver />} />}
      {isExceptionsPage && <Route path={fromExceptionsTracking.ROUTE_VEHICLE} element={<Vehicle />} />}
      {isExceptionsPage && <Route path={fromExceptionsTracking.ROUTE_VARIATIONS} element={<Variations />} />}
      {isExceptionsPage && <Route path={fromExceptionsTracking.ROUTE_SERVICE_BOOKINGS} element={<ServiceBookings />} />}
      {isExceptionsPage && <Route path={fromExceptionsTracking.ROUTE_FBT} element={<FBT />} />}
    </Routes>
  )
}

export default DrillDownRoutes
